<ul ngbNav #nav="ngbNav"
    class="nav-tabs"
    [(activeId)]="activeTab">
    <li *ngFor="let tab of options.tabs; trackByProperty"
        [disabled]="tab.disabled"
        [ngbNavItem]="tab.path">
        <a [routerLink]="[{outlets: {tabContents: tab.path ? [tab.path] : null}}]"
            ngbNavLink>
            {{ tab.name }}
        </a>
    </li>
</ul>

<div class="pt-3 pb-3">
    <router-outlet #routerOutlet
        name="tabContents">
    </router-outlet>
</div>
